export class GiiReport {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}

export const ReportsEnum = {
  PALYG_VMI_ATASK: new GiiReport(1, 'report.apskaitos.vmi.ataskaita'),
  TIEKIMO_RINKAI_ATASKAITA: new GiiReport(2, 'report.apskaitos.tiekimo.rinkai.ataskaita'),
} as const;

export type ReportsEnumKeys = keyof typeof ReportsEnum;

export const reportsList: GiiReport[] = Object.keys(ReportsEnum)
  .filter(key => isNaN(Number(key)))
  .map(key => ReportsEnum[key as ReportsEnumKeys]);
